import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ColorSwatch01 = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M6.00029 9.87443C3.56603 10.639 1.80029 12.9132 1.80029 15.5997C1.80029 18.9135 4.48658 21.5997 7.80029 21.5997C9.47873 21.5997 10.9962 20.9106 12.0852 19.7997C13.1461 18.7175 13.8003 17.235 13.8003 15.5997M18.0003 9.87443C20.4348 10.6388 22.2008 12.9131 22.2008 15.5999C22.2008 18.9136 19.5145 21.5999 16.2008 21.5999C14.8498 21.5999 13.6032 21.1534 12.6003 20.4M18.0003 8.39963C18.0003 11.7133 15.314 14.3996 12.0003 14.3996C8.68658 14.3996 6.00029 11.7133 6.00029 8.39963C6.00029 5.08592 8.68658 2.39963 12.0003 2.39963C15.314 2.39963 18.0003 5.08592 18.0003 8.39963Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default ColorSwatch01
